export default function PhotoActions({
  onClear,
  onSubmit,
  submitLabel = "Continuar pedido",
}) {
  return (
    <div className="photo-actions">
      <button
        type="button"
        onClick={onClear}
        className="photo-reset"
      >
        Limpiar
      </button>

      <button
      type="button"
      onClick={onSubmit}
      className="photo-submit"
    >
        {submitLabel}
      </button>
    </div>
  );
}
